import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/stores-management`;

export const storesManagementRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  edit: `${baseRoute}/edit/:storeId`,
  view: `${baseRoute}/view/:storeId`,
  resetStorePassword: `${baseRoute}/reset/:storeId`,
  subscriptionHistory: `${baseRoute}/subscription-history/:storeId`,
  subscriptionRenewal: `${baseRoute}/subscription-renewal/:storeId`,
} as const;

export type IStoresManagementRouteParams = IExtractRouteParamMap<
  typeof storesManagementRoutesObj
>;

export const storesManagementPath = createPaths<
  typeof storesManagementRoutesObj,
  IStoresManagementRouteParams
>(storesManagementRoutesObj);
